const e = {
  "cdr-heading-serif": "cdr-heading-serif_15-0-1"
};
export {
  e as default
};
